import request from '@/utils/request'

export function userFeedback(params) {
    return request({
      url: 'user/userMessage',
      method: 'get',
        params
    })
  }
  